/**
 * Middlewares
 * Please read http://redux.js.org/docs/advanced/Middleware.html for more details
 **/
import { normalize } from 'normalizr'
import { toastr } from 'react-redux-toastr'

export const REQUEST_SUFFIX = '_REQUEST'
export const SUCCESS_SUFFIX = '_SUCCESS'
export const FAILURE_SUFFIX = '_FAILURE'

const getErrorMessage = (error) => {
  if (error && error.message) return error.message
  if (typeof error === 'string') return error
  return 'Ocurrió un error'
}

// This middleware handles all the fetch requests
// Dispatching a request action and then either a success or failure action
const fetch = store => next => (action) => {
  if (!action.meta || !action.meta.fetch) {
    return next(action)
  }

  const { meta } = action
  if (meta.shouldFetch) {
    const alreadyFetchedValue = meta.shouldFetch(store.getState())
    if (alreadyFetchedValue) {
      return alreadyFetchedValue
    }
  }

  const REQUEST = `${action.types}${REQUEST_SUFFIX}`
  const SUCCESS = `${action.types}${SUCCESS_SUFFIX}`
  const FAILURE = `${action.types}${FAILURE_SUFFIX}`

  const { payload = {} } = action

  // dispatch request action
  next({ type: REQUEST, payload })

  return meta.fetch().then((response) => {
    let value = response
    if (value && value.error) {
      throw value.error
    }

    if (meta.normalize && response) {
      const data = meta.normalizeKey ? response[meta.normalizeKey] : response
      value = normalize(data, meta.normalize)
      if (meta.normalizeKey) {
        value.pagination = {
          total: response.total,
          page: response.page,
          hasMore: response.hasMore,
        }
      }
    }

    if (meta.notification && meta.notification.success) {
      const { title, content } = meta.notification.success
      toastr.success(title, content)
    }

    // dispatch success
    next({ type: SUCCESS, payload: { ...payload, response: value } })

    return value
  }).catch((error) => {
    // if console  only show <Cannot read property 'getHostNode' of null>
    // uncomnet this console.log for more details
    console.error(error)
    const message = getErrorMessage(error)
    toastr.error('Error', message)
    next({
      type: FAILURE,
      error: {
        status: error.status,
        data: 'Bad request',
        ...error,
      },
      payload,
    })
    throw new Error(message)
  })
}

export default fetch
